export function generateColorMatrix(): string[] {
  // Most commonly used t-shirt colors in sports, arranged in 2 rows of 7 colors each
  return [
    // Row 1: Primary and popular colors
    '#FF0000', // Red
    '#0000FF', // Blue
    '#000000', // Black
    '#FFFFFF', // White
    '#FFFF00', // Yellow
    '#008000', // Green
    '#800080', // Purple
    
    // Row 2: Secondary and complementary colors
    '#FFA500', // Orange
    '#FF69B4', // Pink
    '#A52A2A', // Brown
    '#808080', // Gray
    '#00FFFF', // Cyan
    '#4B0082', // Indigo
    '#FF4500', // Orange Red
  ];
} 